module.exports = __webpack_public_path__ + "img/Screen Shot 2021-12-07 at 13.54.19.776b571d.png";